export default __webpack_public_path__ + "static/media/indicator-hold.1baf18e2.svg";